var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgStar = function SvgStar(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none",
    viewBox: "0 0 34 34",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#212123",
    strokeWidth: 1.5,
    d: "M18.664 4.695c-.524-1.612-2.805-1.612-3.328 0l-2.193 6.747a.25.25 0 0 1-.237.173H5.812c-1.695 0-2.4 2.17-1.029 3.165l5.74 4.17a.25.25 0 0 1 .09.28l-2.192 6.746c-.524 1.613 1.321 2.953 2.693 1.957l5.74-4.17a.25.25 0 0 1 .293 0l5.739 4.17c1.372.997 3.217-.344 2.693-1.957l-2.192-6.746a.25.25 0 0 1 .09-.28l5.74-4.17c1.371-.996.666-3.165-1.029-3.165h-7.094a.25.25 0 0 1-.238-.173z",
    opacity: 0.4
  })));
};
export default SvgStar;